<template>
  <div class="doc-sort-btn">
    <a class="doc-sort-btn__link filter-sort" @click="show()">
      <span class="doc-sort-btn__icon iconfont isort"></span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { emitter } from '@/services/mitt'

function show(): void {
  emitter.emit('openSortPopup')
}
</script>

<style lang="scss" scoped>
.doc-sort-btn {
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;

  &__link {
    position: relative;
    @include hover {
      color: $c-black-2;
    }
  }

  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    font-size: 24px;
  }
}

.night-mode .doc-sort-btn {
  @include hover {
    color: $c-dark-4;
  }
  &:before {
    background-color: $c-black-6;
  }
}
</style>
